import { es_US } from '@docupet/component-library';
export default {
    ...es_US,
    discount: {
        notApplyTip: 'Los códigos de promoción no se aplican a tarifas de licencias para mascotas, cargos por pagos atrasados, etiquetas de reemplazo para mascotas, artículos en paquete o artículos de oferta específicos.'
    }
};
